import React from "react";

import WithMainLayout from "../../hocs/layouts/MainLayout";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import { useState } from "react";

function Profile() {
  const [current, setCurrent] = useState("editar");
  return (
    <>
      <div className="block pt-12 pb-32 md:pb-[230px]">
        <nav className="flex items-center space-x-10 md:space-x-12">
          <button
            className={`item-nav${current === "editar" ? " active" : ""}`}
            onClick={() => setCurrent("editar")}
          >
            Editar Perfil
          </button>
          <button
            className={`item-nav${current === "cambiar" ? " active" : ""}`}
            onClick={() => setCurrent("cambiar")}
          >
            Cambiar Contraseña
          </button>
        </nav>
        {current === "editar" && <EditProfile />}
        {current === "cambiar" && <ChangePassword />}
      </div>
    </>
  );
}

export default WithMainLayout(Profile, "Mi Perfil");
